<template>
  <d-row class="my-4">
    <d-col cols="12">
      <d-card>
        <d-card-header
          v-d-toggle.frontend-settings-collapse
          class="cursor-pointer"
        >
          <i
            class="material-icons mr-1 animate"
            :class="{ 'rotate-90': !collapsed }"
            >chevron_right</i
          >
          Frontend Settings
          <div class="text-info">Frontend Settings are display only</div>

        </d-card-header>
        <d-collapse
          id="frontend-settings-collapse"
          @hide="collapsed = true"
          @show="collapsed = false"
        >
          <d-card-body>
            <!-- <form
            v-if="!!product"
            id="add-product-form"
            @submit.prevent="updateProduct"
          > -->
            <vue-form-generator
              :schema="schema"
              :model="model"
              :options="formOptions"
            />
            <!-- <input
              type="submit"
              form="add-product-form"
              value="save"
              class="btn btn-primary"
            /> -->
            <!-- </form> -->
          </d-card-body>
        </d-collapse>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import {
  EDIT_FRONTEND_SETTINGS_SCHEMA,
  FRONTEND_SETTINGS_OPTIONS
} from "./schema";

export default {
  data() {
    return {
      model: {},
      schema: EDIT_FRONTEND_SETTINGS_SCHEMA,
      formOptions: FRONTEND_SETTINGS_OPTIONS,
      collapsed: true
    };
  },
  created() {
    this.model = this.$store.state.settings.settings;
  }
};
</script>

<style lang="scss">
.animate {
  transition: all 0.2s ease-in;
}

.rotate-90 {
  transform: rotate(90deg);
}
</style>
